import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PropertyLeaseHoldersError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PropertyLeaseHoldersError', ...args);
    }
}
export default PropertyLeaseHoldersError;
